// extracted by mini-css-extract-plugin
module.exports = {"cls1":"TaskWorklistsPage-CssProp5_th-module--cls1--1aHdH","cls2":"TaskWorklistsPage-CssProp5_th-module--cls2--2P9gQ TaskWorklistsPage-CssProp5_th-module--cls1--1aHdH"};